import { createContext, ReactNode, useContext } from 'react';

import { useAuth } from '../modules/auth/hooks/useAuth';

// Create auth context with undefined default value
export const AuthContext = createContext<ReturnType<typeof useAuth> | undefined>(undefined);

/**
 * AuthProvider: Manages authentication state and provides auth context to the application
 * Wraps the entire app to ensure auth state is available everywhere
 * @param children - The child components to wrap
 * @returns The AuthProvider component
 */
export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const auth = useAuth();
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};

/**
 * Custom hook to access auth context
 * Throws error if used outside of AuthProvider
 */
export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }
  return context;
};
